import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Frac } from '~lmo/models/frac.model';
import { LmoOrdersService } from '~lmo/services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-home-sandi-status',
  styleUrls: ['./lmo-frac-home-sandi-status.component.scss'],
  templateUrl: './lmo-frac-home-sandi-status.component.html',
})
export class LmoFracHomeSandiStatusComponent implements OnInit {
  public inProgressCount$: Observable<number>;
  public pendingCount$: Observable<number>;
  @Input() public frac: Frac;

  constructor(private orderService: LmoOrdersService) {}

  public ngOnInit() {
    this.inProgressCount$ = this.orderService.inProgress$.pipe(map((inProgressOrders) => inProgressOrders.length));
    this.pendingCount$ = this.orderService.pendingOrders$.pipe(map((pendingOrders) => pendingOrders.length));
  }

  public get timeToNpt(): string | number {
    if (!this.frac.npt) {
      return '14h+';
    }
    return Math.min(...this.frac.npt.map((npt) => npt.currentTimeUntilNPT));
  }

  public get timeToNptNoPending(): string | number {
    if (!this.frac || !this.frac.nptNoPending) {
      return this.timeToNpt;
    }
    const minNPT = Math.min(...this.frac.nptNoPending.map((npt) => npt.predictedMinutesUntilNPT));
    if (minNPT >= 14 * 60) {
      return '14h+';
    }
    return minNPT;
  }
}
